import { Paper, Grid, Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { FormColumn } from 'components/Form/FormColumn';
import { t } from 'i18next';
import {
  MedicalEventDataForm,
  MedicalEventDiagnosticMethod,
  MedicalEventDiagnosticResult,
} from 'models/patientMedicalEvent';

interface FormDiagnosticResultSectionProps {
  form: UseFormReturnType<MedicalEventDataForm, (values: MedicalEventDataForm) => MedicalEventDataForm>;
}

export const FormDiagnosticResultSection = ({ form }: FormDiagnosticResultSectionProps) => {
  return (
    <Paper radius={'md'} p={'md'} withBorder>
      <Grid align={'center'}>
        <FormColumn label={t('add_log_method')}>
          <Select
            required
            data={Object.values(MedicalEventDiagnosticMethod).map((method) => ({
              label: t(`add_log_form_${method}`),
              value: method,
            }))}
            placeholder={t('add_log_method')}
            clearable
            {...form.getInputProps('diagnosticMethod')}
          />
        </FormColumn>
        <FormColumn label={t('add_log_result')}>
          <Select
            required
            data={Object.values(MedicalEventDiagnosticResult).map((result) => ({
              label: t(`add_log_form_${result}`),
              value: result,
            }))}
            placeholder={t('add_log_result')}
            clearable
            {...form.getInputProps('diagnosticResult')}
          />
        </FormColumn>
      </Grid>
    </Paper>
  );
};
